import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { GenerateAffinityResult } from "../../recommendation.types";

export const requestGenerateAffinity =
  async (): Promise<GenerateAffinityResult> => {
    return await instance.post(ApiRoutesRecommendation.AffinityGenerate);
  };
